



import { Component } from '@angular/core';
import { HttpClient} from '@angular/common/http'; 
import { AuthService } from '../../_services/index';
import 'rxjs/add/operator/map'
import * as _ from 'underscore';
import { LoaderService } from 'app/_services/loader.service';
import * as _moment from 'moment';
import * as _rollupMoment from 'moment';
const moment = _rollupMoment || _moment; 
import { utils, write, WorkBook } from 'xlsx';  
import { saveAs } from 'file-saver';
import Swal from 'sweetalert2'
import { environment } from '.../../environments/environment';
import {
  GridDataResult, 
} from '@progress/kendo-angular-grid';

declare var $: any;
 
  

@Component({
  selector: 'uccTransaction-Ucc',
  templateUrl: 'uccDefaulter.component.html', 
})

export class UccDefaulterComponent { 
  search:any
  Employeedata:any
  prjId: any;
  userId: any;
  showLoader: any;
  collectionList: any;
  dataRangeModal: any;
  startDate: any;
  endDate: any;
  defaultStartDate: any;
  defaultEndDate: any; 
  uccMobileList:any;
  dateLink:any;
  geocoder:any;
  uccRecardStatus=false;
  address:any;
  totalAmount:any
  totalTransaction:any
  zoneList:any
  wardList:any
  zoneId:any
  wardId:any
  uccUser:any
  mobile:any
  public gridDataCouponCollection: GridDataResult
  constructor(private http : HttpClient , private auth: AuthService, private loaderService: LoaderService) {
    this.loaderService.status.subscribe((val: boolean) => {
      this.showLoader = val;
    }); 
    this.mobile = null
    this.zoneId = null;
    this.wardId = null;
    var firstDay = new Date();
    var lastDay = new Date(); 
    this.defaultStartDate = (firstDay.getFullYear()) + '-' + (firstDay.getMonth() + 1) + '-' + firstDay.getDate(); 
    this.defaultEndDate = (firstDay.getFullYear()) + '-' + (firstDay.getMonth() + 1) + '-' + firstDay.getDate(); 
    this.dataRangeModal= {beginDate: {year: firstDay.getFullYear(), month: firstDay.getMonth()+1, day: firstDay.getDate()}, endDate: {year: lastDay.getFullYear(), month: lastDay.getMonth()+1, day: lastDay.getDate()}};
  } 

  importUccMobileReportAll(){
    window.open(environment.apiUrl + "uccNew/uccCollectionExl?prjId=" +  this.prjId);
  }

  importUccMobileReport(){
    var data = this.uccMobileList
    const ws_name = 'importUccMobileReport';
    const wb: WorkBook = { SheetNames: [], Sheets: {} };
    const ws: any = utils.json_to_sheet(data);
    wb.SheetNames.push(ws_name);
    wb.Sheets[ws_name] = ws;
    const wbout = write(wb, { bookType: 'xlsx', bookSST: true, type:'binary' });
    saveAs(new Blob([this.s2ab(wbout)], { type: 'application/octet-stream' }), 'uccMobileReport.xlsx');
    } 
    s2ab(s){
      const buf = new ArrayBuffer(s.length);
      const view = new Uint8Array(buf);
      for (let i = 0; i !== s.length; ++i) {
        view[i] = s.charCodeAt(i) & 0xFF;
      };
      return buf;
    }


    deleteConfirmation(data){
      Swal({
        title: 'Are you sure?',
        text: "You won't be able to revert this!",
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes, Convert it!'
      }).then((result) => {
        if (result.value) {
          this.deleteTransaction(data)
        }
      })
    }


    deleteTransaction(data){
      this.http.get(environment.apiUrl + 'ucc/deleteCollection' + "?pushId=" + data.pushId).subscribe(data =>{ 
        var result:any
         result = data
        if (result.status == 200) {
          var msg = result.msg
          Swal(
            '',
            msg,
            'success'
          )

        } else {
          var msg = result.msg
          Swal(
            msg,
            'error'
          )
        }
        
      }); 
    }

    cleanData(array){
      for(var i = 0;i<array.length;i++){
          delete array[i].token 
          delete array[i].deviceId
          delete array[i].tollfree
          delete array[i].vehId
          //delete array[i].pushId
          delete array[i].vehNo
          delete array[i].zoneId
          delete array[i].wardId  
          delete array[i].prjAddress  
          delete array[i].amountSqlCode  
          delete array[i].prjId 
          delete array[i].geoAddress
          delete array[i].collectorUid
          //delete array[i].paymentDate
      }
         return array

    }

    getZone(){
      this.http.get(environment.apiUrl + 'consumer/getZoneByProject?prjid='+this.prjId+'&oemid=7').subscribe(data =>{ 
          this.zoneList= data; 
          
     }); 
  } 
  
    getAllWard(){
     this.http.get(environment.apiUrl + 'consumer/getZoneByProject?prjid='+this.prjId+'&oemid=8').subscribe(data =>{ 
        this.wardList= data; 
        
      }); 
    } 


    
    getUccUser(){
      this.http.get(environment.apiUrl + 'uccnew/uccMobileUser') .subscribe(data => {  
                var result:any
                result = data
                console.log(result)
                this.uccUser = result.data  
                
          }); 
    }

    getWard(){
      this.http.get(environment.apiUrl + 'uccnew/getWardByProject?prjid='+this.prjId+'&userId='+ this.userId) .subscribe(data => {  
                var result:any
                result = data    
                this.zoneList = []
                for(var i = 0;i<result.length;i++){
                  result[i].id = result[i].entityid
                  result[i].entityname = result[i].entityName 
                  this.zoneList.push({entityname:result[i].Zone,id:result[i].ZONEID})
                  this.zoneId = result[i].ZONEID
                }  
                this.wardList= data; 
                if(this.wardList.length == 0){
                  this.getAllWard()
                  this.getZone();
                  this.getUccReceiptReport(this.startDate,this.endDate);
                }else{
                  this.getUccReceiptReport(this.startDate,this.endDate);
                }

                console.log("this.ward",this.wardList)
          }); 
    }

    /*
     * GET UCC RECEIPT REPORT 
     */
    getUccReceiptReport(stDate,edDate){ 
        this.loaderService.display(true);
        this.http.get(environment.apiUrl + 'ucc/getUccDefaulter?prjId='+this.prjId+'&fromDate='+stDate+'&toDate='+edDate + '&zoneId=' + this.zoneId + '&wardId=' + this.wardId + "&mobile="+ this.mobile).subscribe(data =>{  
        var result :any
        result = data
        this.uccMobileList =  result
        if(this.uccMobileList.length>0){
            this.loaderService.display(false);
            this.uccRecardStatus=false;
        } else{
            this.uccRecardStatus=true;
            this.loaderService.display(false);
        }}); 
    }
    

    onDateRangeChanged(dataRange){  
      if(this.startDate!=''||this.startDate!=null||this.startDate!=undefined){ 
        var startDate= dataRange.beginDate.year + "-"  + dataRange.beginDate.month+ "-" + dataRange.beginDate.day 
        var endDate = dataRange.endDate.year + "-"  + dataRange.endDate.month  + "-" + dataRange.endDate.day  
        this.startDate  = moment(startDate).format('YYYY-MM-DD');
        this.endDate = moment(endDate).format('YYYY-MM-DD'); 
        this.getUccReceiptReport(this.startDate,this.endDate)
      }
      else{ 
        this.startDate  = moment(this.defaultStartDate).format('YYYY-MM-DD');
        this.endDate = moment(this.defaultEndDate).format('YYYY-MM-DD'); 
        this.getUccReceiptReport(this.startDate,this.endDate)
      }  
    }

   
  
    viewMapModal(data){  
        console.log(data)
        this.uccRecardStatus=false;
        this.address=data.consumerAddress
        $("#viewMapModal").modal("show"); 
        this.googleMap(data.geolocation._latitude,data.geolocation._longitude); 
    
    }
    

   /*
    * Get LAT LNg by Address
   */ 
  googleMap(lat, lng) {
    var myLatLng = {lat:lat, lng: lng}; 
    var map = new google.maps.Map(document.getElementById('googleMap'), {
      zoom: 17,
      center: myLatLng
    }); 
    var marker = new google.maps.Marker({
      position: myLatLng,
      map: map,
      title: 'Hello World!'
    });
    } 

    selectZone(data){
      if(data){
        this.getUccReceiptReport(this.startDate,this.endDate);
      }else{
        this.zoneId = null
        this.getUccReceiptReport(this.startDate,this.endDate);
      }

    }

    selectUser(data){
      if(data){
        this.getUccReceiptReport(this.startDate,this.endDate);
      }else{
        this.mobile = null
        this.getUccReceiptReport(this.startDate,this.endDate);
      }
    }

    selectWard(data){
      if(data){
        this.getUccReceiptReport(this.startDate,this.endDate);
      }else{
        this.wardId = null
        this.getUccReceiptReport(this.startDate,this.endDate);
      }

    }
    
  



  ngOnInit() { 
    this.startDate  = moment(this.defaultStartDate).format('YYYY-MM-DD');
    this.endDate = moment(this.defaultEndDate).format('YYYY-MM-DD');
    this.prjId = this.auth.getAuthentication().projectId
    this.userId = this.auth.getAuthentication().id 
    this.geocoder = new google.maps.Geocoder;   

    this.getUccUser()
    this.getWard();
  }

  
 
}









// WEBPACK FOOTER //
// ./src/app/reports/uccReport/uccDefaulter.component.ts